/* src/app/modules/dna-syngovia/components/dna-syngovia-carousel/dna-syngovia-carousel.component.scss */
:host {
  height: fit-content;
  width: 100%;
  background: #ecf0f1;
}
.display-flex {
  display: flex;
}
.horizontal-center-layout {
  justify-content: start;
  height: fit-content;
  gap: 0.5rem;
}
.carousel-container {
  overflow: hidden;
  height: fit-content;
  position: relative;
}
.carousel-item {
  flex: 0 0 auto;
  height: inherit;
}
.carousel-container__items {
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -ms-overflow-style: none;
  scrollbar-width: none;
  height: inherit;
  gap: 0.5rem;
}
.carousel-container__items::-webkit-scrollbar {
  display: none;
}
.carousel-button {
  align-self: center;
}
.carousel-item .carousel-container-inner {
  scroll-snap-align: center;
}
/*# sourceMappingURL=dna-syngovia-carousel.component.css.map */
